import React from 'react';

import { formatRelativeTime } from '../../utils/venueUiFormatters';

const formatModifierLabel = (modifier = {}) => {
  const baseLabel = `${modifier.groupName}: ${modifier.optionName}`;
  if (!modifier.priceDelta) {
    return baseLabel;
  }

  const sign = modifier.priceDelta > 0 ? '+' : '-';
  const absoluteAmount = Math.abs(Number(modifier.priceDelta || 0)).toFixed(2);
  return `${baseLabel} (${sign}${absoluteAmount} TRY)`;
};

const ProductionLineCard = ({ item, actionLabel = '', busy = false, onAction = null }) => {
  const modifiers = item?.modifiers || [];

  return (
    <article className="venue-production-card">
      <div className="venue-production-card__top">
        <div>
          <p className="venue-production-card__eyebrow">
            {item?.tableName || 'Masa bilgisi yok'} • #{item?.orderId}
            {!item?.productionAreaId && (
              <span className="venue-production-card__broadcast"> Genel</span>
            )}
          </p>
          <h3 className="venue-production-card__title">
            {item?.quantity}x {item?.itemName}
          </h3>
        </div>
        <span className="venue-production-card__age">
          {formatRelativeTime(item?.sentToProductionAt || item?.orderCreatedAt)}
        </span>
      </div>

      {item?.notes ? (
        <p className="venue-production-card__notes">{item.notes}</p>
      ) : null}

      {modifiers.length > 0 ? (
        <ul className="venue-production-card__modifiers">
          {modifiers.map((modifier, index) => (
            <li key={`${modifier.groupName}-${modifier.optionName}-${index}`}>
              {formatModifierLabel(modifier)}
            </li>
          ))}
        </ul>
      ) : null}

      {actionLabel && typeof onAction === 'function' ? (
        <button
          type="button"
          className="venue-production-card__action"
          onClick={() => onAction(item.orderItemId)}
          disabled={busy}
        >
          {busy ? 'İşleniyor...' : actionLabel}
        </button>
      ) : null}
    </article>
  );
};

export default ProductionLineCard;
